import { render, staticRenderFns } from "./GradingPlanTable.vue?vue&type=template&id=027b9f1a&"
import script from "./GradingPlanTable.vue?vue&type=script&lang=js&"
export * from "./GradingPlanTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports